import React from "react";

export const MisDocumentosContext = React.createContext();